import axios from 'axios'

export default {
  getFile (mnemo, id) {
    return axios.get(`room/${mnemo}/file/${id}`)
  },
  getFileViewerInfo (mnemo, fileId, data, request) {
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    request.cancelToken = source
    return axios.post(
      `room/${mnemo}/file/${fileId}/viewer-info`,
      data,
      { cancelToken: source.token },
    )
  },
  redactDocument (mnemo, fileId, data) {
    return axios.post(`room/${mnemo}/file/${fileId}/redact-pdf`, data)
  },
  async searchByAiStream (mnemo, fileId, { onEntity, onSummary, onError }) {
    // Axios to build the URL, params, etc.
    const url = axios.getUri({
      url: `room/${mnemo}/file/${fileId}/entities`,
      method: 'POST',
    })

    // Fetch to read a ReadableStream (axios doesn't support stream in browser)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(axios.defaults.headers.common || {}),
      },
      body: JSON.stringify({
        room_mnemo: mnemo,
        file_id: fileId,
      }),
      credentials: 'include',
    })

    if (!response.body) {
      throw new Error('Streaming not supported by browser')
    }

    await parseNDJSONStream(response.body, onEntity, onSummary, onError)
  },
}

function parseNDJSONStream (stream, onEntity, onSummary, onError) {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  return reader.read().then(function processChunk({ done, value }) {
    if (done) return
    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split('\n')
    buffer = lines.pop() // Keep incomplete line in buffer

    for (const line of lines) {
      if (!line.trim()) continue

      try {
        const json = JSON.parse(line)
        // Chunk detected entity
        if (json.class === 'entity') {
          onEntity({
            ...json,
            entity_id: String(json.entity_id),
          })
          continue
        }

        // Chunk final summary
        if (json.class === 'entity_norm_values') {
          // Normalize ids to values
          json.entities = json.entities.map(e => ({
            type: e.type,
            norm: e.norm,
            values: e.values ?? e.ids ?? [],
          }))
          onSummary(json)
          continue
        }

        // Unknown chunks
        console.warn('[Redaction AI] Unknown chunk', json)
      } catch (err) {
        onError(err)
      }
    }
    return reader.read().then(processChunk)
  })
}
